<h3 mat-dialog-title class="title">Attachments</h3>

<div mat-dialog-content>
  <attachment-list
    [attachments]="data.attachments"
    [moduleEntityId]="data.moduleEntityId"
    (onAttachmentClicked)="attachmentClicked($event)">
  </attachment-list>
</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null">Close</button>
</div>
